/**
 * 管理后台画布预览的节点模型与类型文案。
 *
 * data 是各节点类型的异构快照，检查器按字段取值，无法收敛成联合类型，
 * 这里集中放开 any，避免每个使用点重复断言。
 */
/* eslint-disable @typescript-eslint/no-explicit-any */

export interface PreviewNode {
  id: string;
  type: string;
  x: number;
  y: number;
  width: number;
  height: number;
  zIndex: number;
  data: Record<string, any>;
}

export const NODE_TYPE_LABELS: Record<string, string> = {
  text: '文本节点',
  image: '图片节点',
  video: '视频节点',
  audio: '声音节点',
  generate_image: '生图节点',
  generate_video: '生视频节点',
  image_group: '图片组',
  video_group: '视频组',
  llm: 'LLM 节点',
  agent: '智能体节点',
  style_card: '风格卡片',
  group: '分组',
};

export function nodeTypeLabel(type: string): string {
  return NODE_TYPE_LABELS[type] || type;
}
